import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NbAccordionModule, NbButtonModule, NbCardModule,NbSpinnerModule, NbTabsetModule, NbTooltipModule } from '@nebular/theme';

import { RequestForApprovalsV2Component } from './request-for-approvals-v2.component';

import { ApprovalDetailsV2Module } from './approval-details-v2/approval-details-v2.module';
import { RequestConfirmationV2Component } from './request-confirmation-v2/request-confirmation-v2.component';
import { ApprovalsV2Module } from './approval-v2/approvals-v2.module';
import { RemindersV2Module } from '../../dynamic-stack/reminders-v2/reminders-v2.module';
import { ForexModule } from '../../dynamic-stack/forex/forex.module';
import { MyRequestAttendanceComponent } from './my-request-attendance/my-request-attendance.component';
import { RouterLink } from '@angular/router';
const component = RequestForApprovalsV2Component



@NgModule({
  declarations: [component, RequestConfirmationV2Component, MyRequestAttendanceComponent],
  imports: [
    CommonModule,
        NbButtonModule,
        FlexLayoutModule,
        RouterLink,
        ApprovalDetailsV2Module,
        NbAccordionModule,
        NbCardModule,
        ApprovalsV2Module,
        NbSpinnerModule,
        RemindersV2Module,
        ForexModule,
        NbTooltipModule,
        NbTabsetModule
  ],
   exports: [component]
})
export class RequestForApprovalsV2Module { }
